import React from 'react';
import { NavLink } from 'react-router-dom';
import '../styles/projects.scss';
import projects from './project-data';

export const ProjectTile = ({ project }) => {
  return (
    <NavLink className="project-tile" to={`/projects/${project.slug}`}>
      <img src={project.img} alt={project.short} style={{ objectPosition: project.imgPosition }} />
      <span>{project.short}</span>
    </NavLink>
  );
};

const ProjectGrid = () => {
  return (
    <div className="project-grid-container">
      <h1>Projects</h1>
      <div className="project-grid">
        {projects.map((p) => <ProjectTile key={p.slug} project={p} />)}
      </div>
    </div>
  );
};

export default ProjectGrid;
